var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("tg-tree", {
    staticClass: "emap-flow-pick-m",
    attrs: {
      keyId: _vm.options,
      keyName: _vm.keyname,
      options: _vm.treeOptions,
      disabledOptions: _vm.disabledoptions,
      "search-options": _vm.treeSearchOptions,
      "parent-selectable": false,
      "is-view": false,
      "is-async": true,
      "has-search": "",
      multiple: _vm.multiple,
    },
    on: {
      "on-search": _vm.loadtreeSearch,
      "selector-click": _vm.loadTreeOptions,
      "selected-click": _vm.getTreeSelected,
    },
    model: {
      value: _vm.showpick,
      callback: function ($$v) {
        _vm.showpick = $$v
      },
      expression: "showpick",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }